import { http } from 'utils'
import { pick, set, concat } from 'lodash'

// Billboard mutation imports.
import { SET_BOOKINGS, ADD_BOOKINGS, SET_BOOKINGS_PAGINATION, SET_FILTER, RESET_FILTERS } from 'vx/mutations'
import initialFiltersState from 'vx/state/booking/billboardFilters'

const state = {
  bookings: [],
  filters: initialFiltersState(),
  pagination: {
    total: 0
  }
}

// Billboard state getters.
const getters = {
  haveNoBillboardBookings: (state) => {
    return state.bookings.length === 0
  },

  initialFiltersState () {
    return initialFiltersState()
  },

  /**
   * Determine if we have no more bookings to load.
   *
   * @return bool
   */
  haveNoMoreBillboardBookings: (state) => {
    return state.pagination.current_page >= state.pagination.last_page ||
      state.pagination.total === 0
  }
}

// Billboard actions.
const actions = {
  /**
   * Get the billboard bookings.
   *
   * @return Promise
   */
  getBillboardBookings ({ commit }, params = {}) {
    return http.get('billboard', { params })
      .then((response) => {
        commit(SET_BOOKINGS, response.data.data)
        commit(SET_BOOKINGS_PAGINATION, response.data.meta)

        return response
      })
  },

  /**
   * Get next set of paginated billboard bookings.
   *
   * @return Promise
   */
  getNextBillboardBookings ({ commit, state, getters }, params = {}) {
    if (getters.haveNoMoreBillboardBookings) {
      return Promise.reject(new Error('There are no more bookings to load.'))
    }

    params.page = state.pagination.current_page + 1

    return http.get(`billboard`, { params })
      .then((response) => {
        commit(ADD_BOOKINGS, response.data.data)
        commit(SET_BOOKINGS_PAGINATION, response.data.meta)

        return response
      })
  },

  setFilter ({ commit }, { filter, value }) {
    commit(SET_FILTER, { filter, value })
  },

  resetFilters ({ commit }) {
    commit(RESET_FILTERS)
  }
}

// Billboard state mutations.
const mutations = {
  [SET_BOOKINGS] (state, bookings) {
    state.bookings = bookings
  },

  [SET_BOOKINGS_PAGINATION] (state, pagination) {
    state.pagination = pick(pagination, ['current_page', 'per_page', 'total', 'last_page', 'prev_page_url', 'next_page_url'])
  },

  [ADD_BOOKINGS] (state, bookings) {
    state.bookings = concat(state.bookings, bookings)
  },

  [SET_FILTER] (state, { filter, value }) {
    set(state.filters, filter, value)
  },

  [RESET_FILTERS] (state) {
    state.filters = initialFiltersState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
